"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignLotteryRequest = void 0;
var SignLotteryRequest = /** @class */ (function () {
    function SignLotteryRequest() {
    }
    return SignLotteryRequest;
}());
exports.SignLotteryRequest = SignLotteryRequest;
;
//# sourceMappingURL=signLottery.request.js.map